import { ReactNode } from "react";
import { Box, BoxProps, Input } from "@mantine/core";

export interface FormItemProps extends BoxProps {
    label?: ReactNode;
    children?: ReactNode;
}

export const FormItem = ({ label, children, ...rest }: FormItemProps) => {
    return (
        <Box {...rest}>
            {label && <Input.Label display="block">{label}</Input.Label>}
            {children}
        </Box>
    );
};
